// extracted by mini-css-extract-plugin
export default {"userRestrictedContainer":"UserRestrictedView-module__userRestrictedContainer__abcFCf8","backToAllIssuesButton":"UserRestrictedView-module__backToAllIssuesButton__CFOXV4V"};